<template>
    <div class="course_introduce">
        <!-- <div class="course_introduce_content" ref="content" :class="{ expanded: isExpanded }">
            <div class="introduce_label">适合人群：</div>
            <div class="introduce_value">
                程序员、IT专业人士、物联网开发者、软件工程师、计算机专业学生及爱好者、有意转型的移动开发者、智能家居行业人员、创业者与产品创程序员、IT专业人士、物联网开发者、软件工程师、计算机专业学生及爱好者、有意转型的移动开发者、智能家居行业人员、创业者与产品创
            </div>
            <div class="introduce_label">你将会学到：</div>
            <div class="introduce_value">全面讲解应用开发流程、工具使用、架构设计、状态管理等，实战为导向，助你快速成为鸿蒙应用开发专家。</div>
            <div class="introduce_label">课程简介：</div>
            <div class="introduce_value">学完本课可免费备考鸿蒙初级+高级认证！扫码添加小助手，提供课程购买记录截图，则可获取备考练习试题！</div>
            <div class="introduce_label">证书模板：</div>
            <div class="introduce_value">
                <el-image class="course_img2" :src="imgPath('course_img2.png')"></el-image>
            </div>
            <div class="introduce_label">证书模板：</div>
            <div class="introduce_value">
                <el-image class="course_img2" :src="imgPath('course_img2.png')"></el-image>
            </div>
            <div class="introduce_label">证书模板：</div>
            <div class="introduce_value">
                <el-image class="course_img2" :src="imgPath('course_img2.png')"></el-image>
            </div>
        </div>
        <div class="more_load flex Flexalign Flexjustify" v-if="showLoadMore" @click="toggleExpand">
            {{ isExpanded ? '收起' : '加载更多' }}
            <el-icon>
                <ArrowDown />
            </el-icon>
        </div> -->
        <div class="rich-text-container" v-html="introduceHtml"></div>
    </div>
</template>

<script>
export default {
    name: 'GjkcH5CourseIntroduce',
    props: {
        courseIntroduce: {}
    },

    data() {
        return {
            isExpanded: false,
            showLoadMore: false,
            introduceHtml: ''
        };
    },
    watch: {
        // items: {
        //     immediate: true,
        //     handler() {
        //         this.$nextTick(this.checkOverflow);
        //     },
        // },
        courseIntroduce: {
            handler(value) {
                if (value) {
                    this.introduceHtml = value.replace(/<img\b([^>]*)>/gi, (match, attributes) => {
                        // 1. 提取原有样式
                        const styleMatch = attributes.match(/style\s*=\s*(["'])(.*?)\1/);
                        let existingStyle = styleMatch ? styleMatch[2] : '';

                        // 2. 添加/合并新样式（保留原有样式）
                        if (!existingStyle.includes('max-width')) {
                            existingStyle = `max-width:100%;height:auto;${existingStyle}`;
                        } else {
                            // 若已有max-width则仅补充height:auto
                            existingStyle = existingStyle.replace(
                                /max-width\s*:[^;]+;/i,
                                '$&height:auto;'
                            );
                        }
                        // 3. 替换或新增style属性
                        return styleMatch
                            ? match.replace(styleMatch[0], ` style="${existingStyle}"`)
                            : match.replace(attributes, ` style="${existingStyle}" ${attributes}`);
                    });
                }
            },
            immediate: true,
        }
    },
    mounted() {
        // this.checkOverflow();
    },

    methods: {
        checkOverflow() {
            if (!this.$refs.content) return
            this.showLoadMore = this.$refs.content.scrollHeight > this.$refs.content.clientHeight;
        },
        toggleExpand() {
            this.isExpanded = !this.isExpanded;
        },
    },
};
</script>
<style lang="scss" scoped>
.course_introduce {
    // max-height: 550px;
    // overflow: hidden;
    position: relative;
    max-width: 100%;
    overflow: auto;
    padding: 20px 0;

    .rich-text-container {
        all: initial;
        /* 重置继承样式（谨慎使用） */
    }

    .rich-text-container p,
    .rich-text-container div {
        margin: 0;
        /* 清除默认外边距 */
        padding: 0;
        /* 清除默认内边距 */
        margin-block-start: 0;
        margin-block-end: 0;
        font-family: unset;
    }
}
</style>